/*
**  rui-record-detail-subheader.js
**
**  rui-record-detail-subheader component
*/
import { LitElement, html, css } from 'lit';
export class RuiRecordDetailSubheader extends LitElement {
    static get is() {
        return 'rui-record-detail-subheader';
    }
    static get properties() {
        return {
            text: { type: String }
        };
    }
    constructor() {
        super();
        this.text = '';
    }
    render() {
        return html `
            <div class="rui-record-detail-subheader">
                <div class="rui-record-detail-subheader-text">${this.text}</div>
                <div class="rui-record-detail-subheader-separator"></div>
                <slot></slot>
            </div>
        `;
    }
    static get styles() {
        return css `
            :host {
                display: block;
                -webkit-font-smoothing: antialiased;
            }
            
            :host(:not(:first-child)) {
                margin-top: 25px;
            }
            
            .rui-record-detail-subheader {
                align-items: center;
                background: transparent;
                border-bottom-color: var(--rui-line, #e0e8f5);
                color: var(--rui-text-bright, #203660);
                display: flex;
                font-family: var(--rui-font-family-chrome, Gellix, "Noto Sans", Roboto, Arial, -apple-system, system-ui, sans-serif);
                font-size: 14px;
                font-weight: 600;
            }
            
            .rui-record-detail-subheader-text {
                flex: auto 0 0 ;
                padding-right: 18px;
                max-width: 100%;
            }
            
            .rui-record-detail-subheader-separator {
                background-color: var(--rui-line, #e0e8f5);
                flex: 1 0 0%;
                width: 100%;
                height: 1px;
            }
            
            ::slotted(rui-info-tooltip),
            ::slotted(jha-field-tooltip) {
                margin-left: 10px;
            }
       
            @media print {
                .rui-record-detail-subheader {
                    color: #000000;
                }
                .rui-record-detail-subheader-text {
                    background-color: #ffffff;
                }
            }
        `;
    }
}
customElements.get(RuiRecordDetailSubheader.is) || customElements.define(RuiRecordDetailSubheader.is, RuiRecordDetailSubheader);
